import { skyFoundationSettings } from '../../services/configs/configs-service';
import { isHomepageInArticle } from '../../utils/injected-hp-utils';

export const HOOK_WRAPPER_PAGE = '.j-wrapper';
export const HOOK_LOCAL_NAV = '.j-local-nav';
export const HOOK_GLOBAL_NAV = '.j-global-nav';
export const HOOK_HP_TABS = '.j-hp-tabs';
export const HOOK_HP_MULTIVIDEO = '.j-video-in-evidenza';
export const HOOK_FOOTER = '.j-footer';
export const HOOK_DTMOBJ = '.j-digital-data';
export const OBSERVER_ELEMENT = 'injected-homepage j-injected-homepage';
export const HOOK_TV_CARD = '.j-tv-card';
export const SELECTOR_RAIL_MOBILE_TOP = '.c-rail-content';

// Selectors/constants for DOM elements
export const SELECTOR_SENTINEL = '.j-injected-homepage-sentinel';
export const SELECTOR_TAG_LIST = '.c-tag-list';
export const SELECTOR_PLAYER_LIVE_CONTAINER = '.j-player-live-container';
export const SELECTOR_PLAYER = '.j-player';
export const SELECTOR_PLAYER_LIVE_CONTAINER_PLAYER = `${SELECTOR_PLAYER_LIVE_CONTAINER} ${SELECTOR_PLAYER}`;
export const SELECTOR_INJECTED_HOMEPAGE = '.j-injected-homepage';
export const SELECTOR_PLAYER_CARD_CLOSE = '.j-player-card__close';
export const SELECTOR_FOOTER_LOGO = '.c-footer__logo';
export const SELECTOR_PARSELY_TOP_VIDEOS = '#parselyTopVideos';
export const SELECTOR_PARSELY_SET_OF_CARDS = '#parselySetOfCards';
export const SELECTOR_RAIL_MOBILE_BOTTOM = '#parselyTopNewsHP';
export const SELECTOR_PARSELY_TOP_NEWS = '#parselyTopNews';
export const SELECTOR_NATIVE_SPONSORED = '.s-native-sponsored';
export const ID_PARSELY_TOP_NEWS_HP = 'parselyTopNewsHP';
export const ID_PARSELY_SET_OF_CARDS_HP = 'parselySetOfCardsHP';

export const INJECTED_HP_ARTICLE_TITLE = document.title;
export const INJECTED_HP_TITLE = skyFoundationSettings.getTitleHomepage();

export const SATELLITE_CHANGE_TRACK = 'change_template';
export const NAV_HEIGHT = 60;

export const $hidePlayer = document.querySelector(SELECTOR_PLAYER_CARD_CLOSE);
export const $railLiveContainer = document.querySelector(SELECTOR_PLAYER_LIVE_CONTAINER);
export const $railLiveSettings = document.querySelector(SELECTOR_PLAYER_LIVE_CONTAINER_PLAYER)
  ? document.querySelector(SELECTOR_PLAYER_LIVE_CONTAINER_PLAYER).outerHTML
  : null;

export const INJECTED_HP_HEADERS = new Headers({
  'Content-Type': 'text/plain',
  'lazy-loaded': isHomepageInArticle(),
});
